<template>
    <div
        v-if="isActive"
        class="absolute z-20 min-w-full p-5 text-black bg-white max-h-80"
    >
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Tab',
        },
        bgcolor: {
            type: String,
            default: '',
        },
        textcolor: {
            type: String,
            default: '',
        },
        click: {
            type: Function,
            default: null,
        },
        clickparam: {
            type: [Number, String],
            default: null,
        },
        imageurl: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isActive: false,
        };
    },
};
</script>
